import { IconButton } from '@frontend/legacy-components';
import { ChevronRightIcon } from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/legacy-components' instead.
 */
const ExpandIcon = ({ expandable, expanded, onExpand, record }) => (
  <IconButton
    onClick={(e) => onExpand(record, e)}
    display={expandable == false ? 'none' : 'flex'}
    mx="auto"
  >
    <ChevronRightIcon
      transition="all 0.25s"
      transform={expanded ? 'rotate(90deg)' : 'unset'}
    />
  </IconButton>
);

export default ExpandIcon;
